import { AVATAR_LABELS } from '@/components/SearchAssistant/constants';
import { Box, Typography } from '@mui/material';

const styles = {
  width: 36,
  height: 36,
  aspectRatio: '1/1',
  borderRadius: '100%',
  display: 'grid',
  placeItems: 'center',
  color: (theme) => theme.palette.common.white,
  backgroundColor: (theme) => theme.palette.baseColors.fireOrange.c100,
};

export const AssistantAvatar = () => {
  return (
    <Box sx={styles}>
      <Typography variant="caption">{AVATAR_LABELS.ASSISTANT_SHORT}</Typography>
    </Box>
  );
};
